import Request from 'utils/request';
import config from 'config/Config';

export default class {
  /**
   * 获取物流详情
   */
  static getLogistics(tradeNo) {
    return Request({
      url: `delivery/manage/query/shippingLog/${tradeNo}`,
      host: config.HOST_MALL
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/Shop/Member/TradeManage/OrderList/Detail/LYLogistics/LYLogisticsServ.js